const prefix = 'SummaryPurchaseRequisitionItem';

export enum SummaryPurchaseRequisitionItemField {
  ID = `${prefix}.id`,
  TITLE = `${prefix}.title`,
  DESCRIPTION = `${prefix}.description`,
  SUPPLIER_NAME = `${prefix}.supplierName`,
  UNIT = `${prefix}.unit`,
  QUANTITY = `${prefix}.quantity`,
  PRICE_PER_UNIT = `${prefix}.pricePerUnit`,
  CURRENCY = `${prefix}.currency`,
  EXTERNAL_ID = `${prefix}.externalId`,
  LINE_ITEM_NUMBER = `${prefix}.lineItemNumber`,
  SUMMARY = `${prefix}.summary`,
  ITEM_ID = `${prefix}.itemId`,
  SUPPLIER_ID = `${prefix}.supplierId`,
  LAST_CHANGED = `${prefix}.lastChanged`,
  COUNT = `${prefix}.count`,
  TOTAL_VALUE = `${prefix}.totalValue`,
}
